(function ($) {
    $(function () {
        $('.iframe--autoheight').on('load', function () {
            iFrameResize({ log: false }, '.iframe--autoheight');
        });
    });
})(jQuery);
